import areaApi from '@/api/config/areaApi'
import { queryKeys } from '@/constant/common'
import { CreateSubArea } from '@/types/areaZone'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function addSubArea(payload: CreateSubArea): Promise<void> {
  await areaApi.createSubArea(payload)
}
const useAddSubArea = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: CreateSubArea) => addSubArea(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.areaZone])
      toast.success(t('addSubAreaSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
  })
}

export default useAddSubArea
